import * as ThemeActionType from "./actions.js"

const themeReducer = (state, action) => {
    switch (action.type) {
        case ThemeActionType.LIGHT_MODE:
            return { darkMode: false }

        case ThemeActionType.DARK_MODE:
            return { darkMode: true }

        default:
            return state
    }
}

export default themeReducer